module.exports = __webpack_public_path__ + "static/media/hero-boucher-mobile.73eba3c8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero-boucher-mobile.webp
// module id = 203
// module chunks = 51